import * as security from "./security";
import * as customer from "./customer";
import * as cart from "./cart";
import * as menu from "./menu";
import * as locale from "./locale";
import * as friendList from "./friendList";
import * as ticket from "./ticket";
import * as cardTransaction from "./cardTransaction";
import * as card from "./card";
import * as deal from "./deal";

export default {
  security,
  customer,
  menu,
  locale,
  cart,
  friendList,
  ticket,
  cardTransaction,
  card,
  deal,
};
